const STORAGE_KEY = 'dmv_quiz_state';
const LANGUAGE_KEY = 'language';

export const saveState = (state) => {
  try {
    // Only save the necessary parts of the state
    const stateToSave = {
      currentState: state.currentState,
      currentLanguage: state.currentLanguage,
      bookmarkedQuestions: state.bookmarkedQuestions,
      answers: state.answers,
      currentQuestion: state.currentQuestion,
      score: state.score
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
  } catch (err) {
    console.error('Error saving state:', err);
  }
};

export const loadState = () => {
  try {
    const savedState = localStorage.getItem(STORAGE_KEY);
    return savedState ? JSON.parse(savedState) : null;
  } catch (err) {
    console.error('Error loading state:', err);
    return null;
  }
};

export const clearState = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (err) {
    console.error('Error clearing state:', err);
  }
};

export const getStoredLanguage = () => {
  try {
    const storedLanguage = localStorage.getItem(LANGUAGE_KEY);
    if (storedLanguage) {
      return storedLanguage;
    }
    // Check browser language
    const browserLang = navigator.language.split('-')[0];
    return ['en', 'es', 'pt'].includes(browserLang) ? browserLang : 'en';
  } catch (err) {
    console.error('Error loading language:', err);
    return 'en';
  }
};

export const saveLanguage = (language) => {
  try {
    localStorage.setItem(LANGUAGE_KEY, language);
  } catch (err) {
    console.error('Error saving language:', err);
  }
};
